var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpgradeProfileBenefits2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 33,
    height: 48,
    rx: 5,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 25,
    height: 33,
    rx: 3,
    fill: "#FFEADB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 19,
    height: 3,
    rx: 1.5,
    fill: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8056 20.743L18.0563 13.2375C17.7721 12.9208 17.2262 12.9208 16.942 13.2375L10.1927 20.743C10.0956 20.8508 10.0318 20.9845 10.0092 21.1278C9.98654 21.2712 10.006 21.4181 10.0652 21.5506C10.1852 21.8215 10.4537 21.9956 10.7499 21.9956H12.2497V27.2495C12.2497 27.4485 12.3287 27.6394 12.4694 27.7802C12.61 27.9209 12.8008 28 12.9997 28H15.2494C15.4483 28 15.639 27.9209 15.7797 27.7802C15.9203 27.6394 15.9993 27.4485 15.9993 27.2495V24.2473H18.999V27.2495C18.999 27.4485 19.078 27.6394 19.2186 27.7802C19.3593 27.9209 19.55 28 19.7489 28H21.9986C22.1975 28 22.3883 27.9209 22.5289 27.7802C22.6696 27.6394 22.7486 27.4485 22.7486 27.2495V21.9956H24.2484C24.3936 21.9963 24.5359 21.9546 24.6579 21.8757C24.7798 21.7968 24.8762 21.684 24.9353 21.5512C24.9944 21.4185 25.0136 21.2713 24.9905 21.1278C24.9675 20.9843 24.9032 20.8506 24.8056 20.743Z",
    fill: "#FF7D23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgradeProfileBenefits2);
export default __webpack_public_path__ + "static/media/icon-upgrade-profile-benefits-2.d9e14bbbc972882d3e01dbac41f557eb.svg";
export { ForwardRef as ReactComponent };